import { useMutation } from "@tanstack/react-query";
import { useCartContext } from "app/providers/CartProvider";
import { toast } from "react-toastify";
import { api } from "shared/api";
import { decryptVoucher } from "shared/utils/voucher";

export const useAccessoireCheckoutRequest = (
  paymentMethod: string,
  bank: string,
) => {
  const cartContext = useCartContext();
  const cart = cartContext.getCart();

  // Function to check if the cart can be checked out
  const canCheckout = () => {
    // There are accessoires in the cart
    if (cart.standardProducts.length > 0) {
      return true;
    }
    return false;
  };
  const checkout = async () => {
    if (!canCheckout()) {
      toast.error("Er is iets foutgegaan bij het plaatsen van uw order");
      return;
    }

    // Determine the delivery method
    let deliveryMethod = "dhl";

    // If all products are zoschoon, set delivery method to zoschoon
    if (
      cart.standardProducts.every(
        (product) => product.deliveryMethod?.code === "zoschoon",
      )
    ) {
      deliveryMethod = "zoschoon";
    }

    const deliveryDate = new Date();
    deliveryDate.setDate(deliveryDate.getDate() + 3);
    const newCart = {
      ...cart,
      delivery: {
        type: deliveryMethod,
        date: deliveryDate.toISOString(),
      },
      discountCode: decryptVoucher(cart.discountCode),
      standardProductPayment: {
        paymentType: "direct",
        paymentBank: parseInt(bank),
        paymentMethod: parseInt(paymentMethod),
      },
    };

    const res = await api().checkout(newCart, { method: "POST" });
    return res.data;
  };

  const {
    mutate: mutateAccesoireCheckout,
    isLoading: isCheckoutRequestLoading,
    isError: isCheckoutRequestFailed,
    data: checkoutRequestData,
  } = useMutation(checkout, {
    onSuccess: (data) => {
      if (!data) {
        toast.error("Er is iets foutgegaan bij het plaatsen van uw order");
        return;
      }
      const { paymentUrl } = data;

      window.location.href = paymentUrl;
    },
    onError: () => {
      toast.error("Er is iets foutgegaan bij het plaatsen van uw order");
    },
  });

  return {
    mutateAccesoireCheckout,
    isCheckoutRequestLoading,
    isCheckoutRequestFailed,
    checkoutRequestData,
  };
};
